import { Button } from '@chakra-ui/react';
import { isRelativeUrl } from '@waitroom/utils';
import { ReactElement, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { routes } from '../../../../../../../constants/routes';
import {
  defaultPageTypes,
  useCmsPagesFooterMenu,
} from '../../../../../../cms/hooks/useCmsPagesMenu';

const FooterMenuItem = ({ text, url }: { text: ReactNode; url?: string }): ReactElement | null => {
  if (!url) return null;
  const btn = (
    <Button
      color="white"
      variant="link"
      size="def"
      fontWeight="normal"
      minW={0}
      py={2}
      pl={2}
      pr={2}
      mr={6}
      type="button"
    >
      {text}
    </Button>
  );
  return (
    <div>
      {!isRelativeUrl(url) ? (
        <Link to={url} className="simple">
          {btn}
        </Link>
      ) : (
        <a href={url} target="_blank" rel="nofollow noopener noreferrer" className="simple">
          {btn}
        </a>
      )}
    </div>
  );
};

const FooterMenu = (): ReactElement | null => {
  const { items } = useCmsPagesFooterMenu(defaultPageTypes);
  return (
    <>
      {items?.map((page, i) => {
        return (
          <FooterMenuItem
            key={i}
            text={page.menuTitle || page.title}
            url={page.url || `${routes.PAGE.link}/${page.slug?.current || page._id}`}
          />
        );
      })}
    </>
  );
};
export default FooterMenu;
